import { useEffect } from 'react';
import { useProgressTimer } from './use-progress-timer';

export const useCompareProgress = (
  status: string | undefined,
  isRecalculating: boolean,
  isGeneratingEstimates: boolean,
): number => {
  const { progress, resetProgress, startProgress, stopProgress } = useProgressTimer();

  useEffect(() => {
    if (!status && !isRecalculating && !isGeneratingEstimates) {
      resetProgress();
      return;
    }
    if (isGeneratingEstimates || isRecalculating) {
      startProgress(99);
    } else {
      resetProgress();
    }
    return () => {
      stopProgress();
    };
  }, [status, isGeneratingEstimates, isRecalculating, resetProgress, startProgress, stopProgress]);

  return progress;
};
